import React, { useState } from "react"

import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from "@material-ui/core"
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons"

import BannerUtil from "@/utils/banner"

import StorageService from "@/services/Storage"

import { useGlobalStateStore } from "@/store/GlobalState"

import BannersCarousel from "@/pages/Admin/Dashboard/Banners/BannersCarousel"

import useStyles from "@/pages/Admin/Dashboard/Banners/styles"

const NEWS_BANNERS_DASHBOARD_STORAGE_KEY = "inbox:show-news-banners-dashboard"
type NewsBannersDashboard = {
	expandedAccordionDefault: boolean
}

const Banners: React.FC = () => {
	const classes = useStyles()
	const globalStateStore = useGlobalStateStore()
	// const userPreference = StorageService.get<NewsBannersDashboard>(NEWS_BANNERS_DASHBOARD_STORAGE_KEY)

	const [expandedAccordion, setExpandedAccordion] = useState(true)

	const saveUserPreference = () => {
		StorageService.set<NewsBannersDashboard>(NEWS_BANNERS_DASHBOARD_STORAGE_KEY, {
			expandedAccordionDefault: !expandedAccordion
		})
	}

	const handleExpandedAccordionChange = () => {
		setExpandedAccordion(!expandedAccordion)
		saveUserPreference()
	}

	const banners = BannerUtil.mountBanners(globalStateStore.currentChannel?.channelType)

	const shouldDisplayBanners = banners.length > 0

	if (!shouldDisplayBanners) {
		return null
	}

	return (
		<Grid container>
			<Grid item xs={12}>
				<Accordion
					expanded={expandedAccordion}
					onChange={handleExpandedAccordionChange}
					className={classes.accordion}
				>
					<AccordionSummary
						id="banners-header"
						aria-controls="banners-content"
						expandIcon={<ExpandMoreIcon />}
						className={classes.accordionSummary}
						IconButtonProps={
							{
								classes: {
									root: classes.accordionSummaryIcon
								}
							}
						}
					>
						<Grid container justifyContent="flex-end">
							<Grid item>
								<Typography className={classes.accordionSummaryText}>
									{expandedAccordion ? "Ocultar destaques" : "Mostrar destaques"}
								</Typography>
							</Grid>
						</Grid>
					</AccordionSummary>
					<AccordionDetails className={classes.accordionDetails}>
						<Grid container direction="row">
							<Grid item xs={12}>
								<BannersCarousel banners={banners}/>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
			</Grid>
		</Grid>

	)
}

export default Banners
